import ToggleUIConfig from 'models/ButtonConfig';
import {
    ADULT,
    DEFAULT_PROFILE_PIC,
    DEFAULT_LOCALE,
    DEFAULT_KIDS_BUTTON_IMAGE,
} from 'helpers/ProfileConstants';
import { getLocale } from 'services/LocalizationService';

export const FALLBACK_AVATAR =
    'https://wwwimage-secure.cbsstatic.com/base/files/asset/10/00/96/99/3b80b0fcf28539c8_fallback_avatar.png';

const windowsClass = navigator.userAgent.indexOf('Win') != -1 ? 'buttonWindows_UserProfile' : '';

export class UserProfile {
    constructor() {
        this.id = null;
        this.name = null;
        this.profilePic = DEFAULT_PROFILE_PIC;
        this.profilePicPath = null;
        this.profileType = ADULT;
        this.locale = DEFAULT_LOCALE;
    }
}

/**
 * @param key { string }
 * @param config { object }
 *
 * @return { object }
 */
export const labeledInputConfig = (key, overrideConfig) => {
    let defaultConfig = {
        type: 'text',
        name: key,
        label: key,
        value: '',
        ref: key,
    };

    if (overrideConfig && typeof overrideConfig === 'object') {
        return Object.assign(defaultConfig, overrideConfig);
    } else {
        return defaultConfig;
    }
};

export const UserProfileCreateConfig = () => {
    return {
        inputList: {
            profileName: {
                value: '',
                type: 'text',
                label: getLocale('profile_name'),
                tabIndex: 1,
                ref: 'profile_name',
                maxlength: 50,
                styleClass: ['qt-emailtxtfield'],
            },
            ageGroupSwitch: new ToggleUIConfig({
                id: 'parental-switch',
                value: false,
                styleClass: 'switch-toggle-dark',
            }),
        },
        buttonSubmitConfig: {
            type: 'submit',
            displayText: getLocale('save_profile'),
            tabIndex: 3,
            styleClass: ['button', 'primary', 'focusable', windowsClass],
        },
        buttonCancelConfig: {
            type: 'button',
            displayText: getLocale('save_profile_cancel'),
            tabIndex: 3,
            styleClass: ['button', 'secondary', 'focusable', windowsClass],
        },
        buttonDeleteConfig: {
            type: 'button',
            displayText: getLocale('delete_profile_'),
            tabIndex: 3,
            styleClass: ['button', 'secondary', 'focusable', windowsClass],
        },
        buttonCreatePin: {
            type: 'submit',
            displayText: getLocale('create_pin'),
            tabIndex: 3,
            styleClass: ['button', 'primary', 'focusable', windowsClass],
        },
    };
};

export const UserProfileDeleteConfig = () => {
    return {
        buttonConfig: {
            submit: {
                displayText: getLocale('yes_delete_profile'),
                styleClass: ['button', 'primary', 'focusable', windowsClass],
            },
            cancel: {
                displayText: getLocale('no_keep_profile_'),
                styleClass: ['button', 'secondary', 'focusable', windowsClass],
            },
            kidsButtonSubmit: {
                displayText: getLocale('yes_im_sure'),
                styleClass: ['button', 'primary', 'focusable'],
            },
            kidsButtonCancel: {
                displayText: getLocale('no_keep_going'),
                styleClass: ['button', 'secondary', 'focusable'],
            },
        },
    };
};
export const DeleteKidsButtonConfig = () => {
    return {
        kidsButtonConfig: {
            id: null,
            name: getLocale('add_kids_profile'),
            profileType: 'KIDS',
            isLocked: true,
            isMasterProfile: false,
            profilePic: null,
            profilePicPath: DEFAULT_KIDS_BUTTON_IMAGE,
        },
    };
};

export const ConfirmPasswordConfig = {
    inputList: {
        password: labeledInputConfig('password', {
            type: 'password',
            label: getLocale('password', {}),
            tabIndex: 0,
            maxlength: 30,
            styleClass: ['qt-pwdtxtfield', 'password-field'],
            autoComplete: 'off',
        }),
    },
    buttonConfig: {
        displayText: getLocale('_continue'),
        event: function (e) {},
        tabIndex: 0,
        styleClass: ['button', 'primary', 'focusable'],
    },
};
